import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";

export function getExpenseAccounts(context) {  //20250213
    const {
        expensegroups,
        expenseaccounts,
        currencies,
        exchangerates,
    } = context;

    const generalledgerdata = getGeneralLedgerData(context);
    let filteredledgerdata = generalledgerdata
        .filter(data => data.accounttype == 'expenseaccounts')

    const data = [];

    let sortedgroups = expensegroups.sort((a, b) => {
        return a.orderid - b.orderid;
    });

    sortedgroups.forEach((group) => {
        let groupedaccounts = expenseaccounts.filter(account => account.groupid == group.id)
        let sortedgroupedaccounts = groupedaccounts.sort((a, b) => {
            return a.orderid - b.orderid;
        });
        data.push({
            id: group.id,
            name: group.name,
            tabletype: 'group'
        });

        sortedgroupedaccounts.forEach((account) => {
            let accountledgers = filteredledgerdata
                .filter(data => data.accountid == account.id)

            let currencysymbol = currencies.find(curr => curr.id == account.currencyid)?.symbol

            data.push({
                id: account.id,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencysymbol,
                balance: getledgerbalance(accountledgers, exchangerates, account.currencyid, 'expenseaccounts'),
                tabletype: 'account',
                type: 'expenseaccounts'
            });
        });
    });

    let ungroupedaccounts = expenseaccounts
        .filter(account => account.groupid === '')
        .sort((a, b) => a.orderid - b.orderid);

    ungroupedaccounts.forEach((account) => {
        let accountledgers = filteredledgerdata
            .filter(data => data.accountid == account.id)

        let currencysymbol = currencies.find(curr => curr.id == account.currencyid)?.symbol

        data.push({
            id: account.id,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencysymbol,
            balance: getledgerbalance(accountledgers, exchangerates, account.currencyid, 'expenseaccounts'),
            tabletype: 'account',
            type: 'expenseaccounts'
        });
    });

    return data;
}
